import { defineStore } from 'pinia';
import { onScopeDispose, ref } from 'vue';

export const VIEW_LOADING_BATCH_SETTLE_DELAY = 50;
export const VIEW_LOADING_ROUTE_SETTLE_DELAY = 120;

export const useViewLoadingStore = defineStore('core-view-loading', () =>
{
    const loading = ref(false);
    const collecting = ref(false);
    const generation = ref(0);
    const pending = ref(0);
    const label = ref('[[[Wczytywanie]]]');
    let settleTimer: ReturnType<typeof setTimeout> | null = null;

    function clearSettleTimer()
    {
        if (settleTimer !== null)
            globalThis.clearTimeout(settleTimer);

        settleTimer = null;
    }

    function settle()
    {
        if (pending.value > 0)
            return;

        clearSettleTimer();
        collecting.value = false;
        loading.value = false;
    }

    function scheduleSettle(delay: number)
    {
        clearSettleTimer();
        settleTimer = globalThis.setTimeout(settle, delay);
    }

    function beginNavigation(nextLabel: string = '[[[Wczytywanie]]]')
    {
        clearSettleTimer();
        generation.value += 1;
        pending.value = 0;
        collecting.value = true;
        label.value = nextLabel;

        return generation.value;
    }

    function finishNavigationWindow()
    {
        if (collecting.value && pending.value === 0)
            scheduleSettle(VIEW_LOADING_ROUTE_SETTLE_DELAY);
    }

    function startRequest()
    {
        if (!collecting.value)
            return null;

        clearSettleTimer();
        pending.value += 1;
        loading.value = true;

        return generation.value;
    }

    function finishRequest(requestGeneration: number | null)
    {
        if (!collecting.value || requestGeneration === null || requestGeneration !== generation.value)
            return;

        pending.value = Math.max(0, pending.value - 1);

        if (pending.value === 0)
            scheduleSettle(VIEW_LOADING_BATCH_SETTLE_DELAY);
    }

    function reset()
    {
        clearSettleTimer();
        loading.value = false;
        collecting.value = false;
        pending.value = 0;
    }

    onScopeDispose(clearSettleTimer);

    return {
        loading,
        collecting,
        generation,
        pending,
        label,
        beginNavigation,
        finishNavigationWindow,
        startRequest,
        finishRequest,
        reset
    };
});
